import {BaseStore, globalStore} from "../../../../stem-core/state/Store";
import {field} from "../../../../stem-core/state/StoreField.js";
import {Merchant} from "../../MerchantStore";

@globalStore
export class MerchantCDSProduct extends BaseStore("MerchantCDSProduct") {
    @field("Merchant") merchant: Merchant;
    @field(String) productId: string;
    @field(Boolean) canMakeSubscription: boolean;
    @field(Boolean) canMakeDonations: boolean;
    @field(Number) cdsAppId: number;

    toString() {
        return this.productId;
    }
}
